import { hGrey } from "../../theme";

export const useInfluencerAddressStyle = {
  addressCard: {
    width: "100%",
    borderRadius: "20px",
    marginBottom: "20px",
  },
  addressCardHeader: {
    backgroundColor: "primary.main",
    textAlign: "center",
    height: "42px",
    padding: "0",
    fontWeight: "bold",
  },
  cardContent: {
    padding: "0 20px 0",
  },
  cardActionBox: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    pb: 4,
    pt: 3,
  },
  line: {
    width: "100%",
    borderTop: "0",
    borderLeft: "0",
    borderRight: "0",
    borderBottom: `1px solid ${hGrey[100]}`,
    margin: 0,
  },
  addressIconBox: {
    display: "flex",
    alignItems: "center",
    fontSize: "24px",
    paddingRight: "6px",
  },
  addressDetailBox: {
    paddingTop: "8px",
  },
  rateCardEditIcon: {
    border: "1px solid",
    borderColor: "primary.main",
    fontSize: "16px",
  },
};

export const useEditAddressDialogStyle = {
  dialog: {
    "& .MuiDialog-container .MuiPaper-root.MuiDialog-paper": {
      minWidth: ["90%", "90%", "90%", "670px"],
      margin: [1, 2, 3],
    },
  },
  dialogContent: {
    paddingTop: 3,
    paddingBottom: 0,
  },
};
